import Typed from "typed.js";
import { useEffect, useRef } from "react";

export default function DynamicIntro() {
  const el = useRef(null);
  const typed = useRef(null);
  useEffect(() => {
    const options = {
      strings: ["publish data openly,", "manage internal data,"],
      typeSpeed: 50,
      backSpeed: 50,
      loop: true,
    };
    typed.current = new Typed(el.current, options);
    return () => {
      typed.current.destroy();
    };
  }, []);
  return (
    <section className="overflow-hidden relative max-w-screen w-screen pt-32 pb-96 bg-center font-['Inter'] left-0 right-0">
      <div className="bg-[#F7F8F9] max-w-screen w-screen absolute p-16 left-0 " tabIndex={0}>
        <div className="my-8 text-center text-maingray text-xl sm:text-2xl md:text-3xl lg:text-4xl leading-normal md:leading-[3rem] font-medium xl: h-[7rem] lg:h-[6rem] md:h-[7rem] sm:h-[6rem] h-[8rem]">
          <h3 className="">Whether you are looking to</h3>
          <span
            className="text-orange-400 overflow-hidden"
            ref={el}
            style={{ whiteSpace: "pre" }}
          ></span>
          <span className="block">CKAN lets you build systems that scale.</span>
        </div>
      </div>
    </section>
  );
}
